SLIDE_ANIM_DURATION = 200

App.DeliveryRestaurantSubmenuComponent = Em.Component.extend
  classNames: 'delivery-restaurant-submenu'

  session: Em.inject.service()

  restaurant: null
  zones: []

  classNameBindings: ['isActive:active']
  isActive: true

  selectedRestaurant: null

  # ---
  # Выбран ли этот ресторан
  # ---
  isSelected: (->
    @get('restaurant.id') == @get('selectedRestaurant.id')
  ).property('restaurant.id', 'selectedRestaurant.id')

  # --
  # Список зон только этого ресторана
  # ---
  filteredZones: (->
    zones = @get('zones')
    restaurant = @get('restaurant')

    @get('zones')
    .filter (zone) =>
      zone.get('restaurant.id') is restaurant.get('id') and not zone.get('isNew')
  ).property(
    'restaurants',
    'zones.@each.restaurant.id',
    'zones.@each.isNew')

  # ---
  # Сворачивание/разворачивание списка
  # ---
  isSelectedWas: null
  onIsSelectedChanged: (->
    oldValue = @get('isSelectedWas')
    newValue = @get('isSelected')

    if newValue isnt oldValue
      return unless @$() or @get('isDestroyed')

      if newValue
        @$('.zones-list').slideDown(SLIDE_ANIM_DURATION)
      else
        @$('.zones-list').slideUp(SLIDE_ANIM_DURATION)

    @set('isSelectedWas', newValue)
  ).observes('isSelected').on('didInsertElement')

  actions:
    onAddElementClicked: ->
      @sendAction('onAddElementClicked', @get('restaurant'))
      false

    onHeaderClicked: ->
      @sendAction('onHeaderClicked', @get('restaurant'))
      false